import { render } from "./rodape.vue?vue&type=template&id=7e1afff0&scoped=true"
import script from "./rodape.vue?vue&type=script&lang=js"
export * from "./rodape.vue?vue&type=script&lang=js"

import "./rodape.vue?vue&type=style&index=0&id=7e1afff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1afff0"]])

export default __exports__